import { render, staticRenderFns } from "./inspectionRectify.vue?vue&type=template&id=bc572354&scoped=true&"
import script from "./inspectionRectify.vue?vue&type=script&lang=js&"
export * from "./inspectionRectify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc572354",
  null
  
)

export default component.exports